<template>
  <v-container fluid>
    <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Permissão padrão</h2>

    <v-skeleton-loader :loading="loadPage" transition="fade-transition" height="auto" type="list-item-two-line">
      <v-card class="pl-2 pr-2 pt-2">
        <v-row>
          <v-col class="pt-0 d-flex flex-column justify-center align-center offset-md-1" :cols="$vuetify.breakpoint.xs ? '6' : '12'" sm="2" md="2">
            Fields
            <v-switch class="pt-0 pl-1 pb-1" dense color="primary" :loading="defaultFieldsLoading" v-model="defaultFields" hide-details></v-switch>
          </v-col>

          <v-col class="pt-0 d-flex flex-column justify-center align-center" :cols="$vuetify.breakpoint.xs ? '6' : '12'" sm="2" md="2">
            Actions
            <v-switch class="pt-0 pl-1 pb-1" dense color="primary" :loading="defaultActionsLoading" v-model="defaultActions" hide-details></v-switch>
          </v-col>

          <v-col class="pt-0 d-flex flex-column justify-center align-center" :cols="$vuetify.breakpoint.xs ? '6' : '12'" sm="2" md="2">
            Tabs
            <v-switch class="pt-0 pl-1 pb-1" dense color="primary" :loading="defaultTabsLoading" v-model="defaultTabs" hide-details></v-switch>
          </v-col>

          <v-col class="pt-0 d-flex flex-column justify-center align-center" :cols="$vuetify.breakpoint.xs ? '6' : '12'" sm="2" md="2">
            Steps
            <v-switch class="pt-0 pl-1 pb-1" dense color="primary" :loading="defaultStepsLoading" v-model="defaultSteps" hide-details></v-switch>
          </v-col>

          <v-col class="pt-0 d-flex flex-column justify-center align-center" :cols="$vuetify.breakpoint.xs ? '6' : '12'" sm="2" md="2">
            Menus
            <v-switch class="pt-0 pl-1 pb-1" dense color="primary" :loading="defaultMenusLoading" v-model="defaultMenus" hide-details></v-switch>
          </v-col>
        </v-row>
      </v-card>
    </v-skeleton-loader>

    <v-radio-group v-model="toggleFirstTable" hide-details dense :row="$vuetify.breakpoint.xs ? false : true">
      <v-radio color="primary" label="Páginas" value="pages"></v-radio>
      <v-radio color="primary" label="Menus" value="menus"></v-radio>
      <v-radio color="primary" label="Usuários" value="users"></v-radio>
      <v-radio color="primary" label="Grupos" value="groups"></v-radio>
    </v-radio-group>

    <!-- First table pages! -->
    <template v-if="toggleFirstTable === 'pages'">
      <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Páginas</h2>

      <v-skeleton-loader :loading="loadPage" transition="fade-transition" height="auto" type="table-tbody">
        <v-data-table
          dense
          :headers="headersPages"
          :items="pages"
          :items-per-page="10"
          :search="searchPages"
          class="elevation-1 mb-2"
          :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
        >
          <template v-slot:top>
            <v-card-title class="pt-1 elevation-0">
              <v-spacer></v-spacer>
              <v-text-field v-model="searchPages" append-icon="search" label="Pesquisar" single-line hide-details id="input-search"></v-text-field>
            </v-card-title>
          </template>

          <template v-slot:[`item.action`]="{ item }">
            <v-layout justify-space-between>
              <v-icon small color="primary" @click="handleSetPage(item)">edit</v-icon>
            </v-layout>
          </template>
        </v-data-table>
      </v-skeleton-loader>
    </template>

    <!-- First table menus! -->
    <template v-if="toggleFirstTable === 'menus'">
      <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Menus</h2>

      <v-data-table
        dense
        :headers="headersMenus"
        :items="menus"
        :items-per-page="10"
        :search="searchMenus"
        class="elevation-1 mb-2"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
      >
        <template v-slot:top>
          <v-card-title class="pt-1 elevation-0">
            <v-spacer></v-spacer>
            <v-text-field v-model="searchMenus" append-icon="search" label="Pesquisar" single-line hide-details id="input-search"></v-text-field>
          </v-card-title>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-layout justify-space-between>
            <v-icon small color="primary" @click="handleSetMenu(item)">edit</v-icon>
          </v-layout>
        </template>
      </v-data-table>
    </template>

    <!-- First table users! -->
    <template v-if="toggleFirstTable === 'users'">
      <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Usuários</h2>

      <v-data-table
        dense
        :headers="headersUsersInitial"
        :items="users"
        :items-per-page="10"
        :search="searchUsers"
        class="elevation-1 mb-2"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
      >
        <template v-slot:top>
          <v-card-title class="pt-1 elevation-0">
            <v-spacer></v-spacer>
            <v-text-field v-model="searchUsers" append-icon="search" label="Pesquisar" single-line hide-details id="input-search"></v-text-field>
          </v-card-title>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-layout justify-space-between>
            <v-icon small color="primary" @click="handleSetUsers(item)">edit</v-icon>
          </v-layout>
        </template>
      </v-data-table>
    </template>

    <!-- First table groups! -->
    <template v-if="toggleFirstTable === 'groups'">
      <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Grupos</h2>

      <v-data-table
        dense
        :headers="headersGroupsInitial"
        :items="groups"
        :items-per-page="10"
        :search="searchGroups"
        class="elevation-1 mb-2"
        :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
      >
        <template v-slot:top>
          <v-card-title class="pt-1 elevation-0">
            <v-spacer></v-spacer>
            <v-text-field v-model="searchGroups" append-icon="search" label="Pesquisar" single-line hide-details id="input-search"></v-text-field>
          </v-card-title>
        </template>

        <template v-slot:[`item.action`]="{ item }">
          <v-layout justify-space-between>
            <v-icon small color="primary" @click="handleSetGroups(item)">edit</v-icon>
          </v-layout>
        </template>
      </v-data-table>
    </template>

    <!-- Dialog pages! -->
    <v-dialog v-model="dialog" fullscreen hide-overlay transition="scroll-y-transition">
      <v-card>
        <v-toolbar dark color="primary rounded-0">
          <v-toolbar-title>Página: {{ titlePage }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text dark @click="handleSavePermissionsByPage" v-if="itemActive.length">Salvar</v-btn>
            <v-btn icon dark @click="dialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <v-card class="mx-auto mt-4 mb-0" v-if="items.length">
            <v-sheet class="pa-4 primary">
              <v-text-field
                v-model="search"
                label="Pesquisar"
                flat
                solo-inverted
                hide-details
                clearable
                dense
                clear-icon="mdi-close-circle-outline"
              ></v-text-field>
            </v-sheet>
          </v-card>

          <v-row class="pa-0" justify-space-between>
            <v-col cols="12" sm="12" md="5">
              <v-treeview
                :items="items"
                :search="search"
                :filter="filter"
                :value="[]"
                :open="open"
                @update:active="handleActiveItem"
                return-object
                color="primary"
                dense
                activatable
                hoverable
                transition
                open-on-click
                expand-icon="mdi-chevron-down"
              >
                <template v-slot:label="{ item }">{{ item.name[0].toUpperCase() + item.name.slice(1) }}</template>
              </v-treeview>
            </v-col>

            <v-col cols="12" sm="12" md="7" id="permissionsTable">
              <div v-if="itemActive.length">
                <v-layout>
                  <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Usuários</h2>

                  <v-spacer></v-spacer>
                </v-layout>

                <v-data-table
                  dense
                  :headers="usersListPermissionsHeaders"
                  :items="usersListPermissions"
                  :items-per-page="10"
                  :search="searchUsers"
                  :loading="loadTable"
                  class="elevation-1 mb-2"
                  :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
                >
                  <template v-slot:top>
                    <v-card-title class="pt-1 elevation-0">
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="searchUsers"
                        append-icon="search"
                        label="Pesquisar"
                        single-line
                        hide-details
                        id="input-search"
                      ></v-text-field>
                    </v-card-title>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-layout justify-space-between>
                      <v-select
                        :items="itemsFields"
                        v-model="item.permission"
                        label="Fields"
                        append-icon="zmdi zmdi-chevron-down"
                        dense
                        :flat="true"
                        :full-width="true"
                        :height="16"
                        :hide-details="true"
                        hide-selected
                        single-line
                        small-chips
                        solo
                        background-color="transparent"
                        @change="handleSetUpdatedUserPermissions(item)"
                      ></v-select>
                    </v-layout>
                  </template>
                </v-data-table>

                <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Grupos</h2>

                <v-data-table
                  dense
                  :headers="headersGroupsListPermissions"
                  :items="groupsListPermissions"
                  :items-per-page="10"
                  :search="searchGroups"
                  :loading="loadTable"
                  class="elevation-1 mb-2"
                  :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
                >
                  <template v-slot:top>
                    <v-card-title class="pt-1 elevation-0">
                      <v-spacer></v-spacer>
                      <v-text-field
                        v-model="searchGroups"
                        append-icon="search"
                        label="Pesquisar"
                        single-line
                        hide-details
                        id="input-search"
                      ></v-text-field>
                    </v-card-title>
                  </template>

                  <template v-slot:[`item.action`]="{ item }">
                    <v-layout justify-space-between>
                      <v-select
                        :items="itemsFields"
                        v-model="item.permission"
                        label="Fields"
                        append-icon="zmdi zmdi-chevron-down"
                        dense
                        :flat="true"
                        :full-width="true"
                        :height="16"
                        :hide-details="true"
                        hide-selected
                        single-line
                        small-chips
                        solo
                        background-color="transparent"
                        @change="handleSetUpdatedGroupPermissions(item)"
                      ></v-select>
                    </v-layout>
                  </template>
                </v-data-table>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog menus! -->
    <v-dialog v-model="dialogMenus" fullscreen transition="scroll-y-transition">
      <v-card class="rounded-0 elevation-0">
        <v-toolbar dark color="primary rounded-0">
          <v-toolbar-title>Menu: {{ currentMenu.name }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text dark @click="handleSavePermissionsByMenu">Salvar</v-btn>
            <v-btn icon dark @click="checkForChangesDialogMenus">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Usuários</h2>

          <v-data-table
            :headers="headersUsersOrGroupsByMenu"
            :items="itemsUsersByMenu"
            :items-per-page="10"
            :search="searchGroupsDialog"
            :loading="loadTableDialog"
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:top>
              <v-card-title class="pt-1 elevation-0">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchGroupsDialog"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                  id="input-search"
                ></v-text-field>
              </v-card-title>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-layout justify-space-between>
                <v-select
                  :items="itemsFields"
                  v-model="item.permission"
                  label="Fields"
                  append-icon="zmdi zmdi-chevron-down"
                  dense
                  :flat="true"
                  :full-width="true"
                  :height="16"
                  :hide-details="true"
                  hide-selected
                  single-line
                  small-chips
                  solo
                  background-color="transparent"
                  @change="handleSetUpdatedUserPermissionsDirect(item)"
                ></v-select>
              </v-layout>
            </template>
          </v-data-table>

          <h2 class="mt-2 mb-2 text-h6 font-italic font-weight-black">Grupos</h2>

          <v-data-table
            :headers="headersUsersOrGroupsByMenu"
            :items="itemsGroupsByMenu"
            :items-per-page="10"
            :search="searchGroupsDialog"
            :loading="loadTableDialog"
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:top>
              <v-card-title class="pt-1 elevation-0">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchGroupsDialog"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                  id="input-search"
                ></v-text-field>
              </v-card-title>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-layout justify-space-between>
                <v-select
                  :items="itemsFields"
                  v-model="item.permission"
                  label="Fields"
                  append-icon="zmdi zmdi-chevron-down"
                  dense
                  :flat="true"
                  :full-width="true"
                  :height="16"
                  :hide-details="true"
                  hide-selected
                  single-line
                  small-chips
                  solo
                  background-color="transparent"
                  @change="handleSetUpdatedGroupPermissionsDirect(item)"
                ></v-select>
              </v-layout>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog users! -->
    <v-dialog v-model="dialogUsers" fullscreen hide-overlay transition="scroll-y-transition">
      <v-card>
        <v-toolbar dark color="primary rounded-0">
          <v-toolbar-title>Usuário: {{ currentUser.userName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn text dark @click="handleSavePermissionsByUser" v-if="toggleDialogUsersTable !== 'menus'">Salvar</v-btn>
            <v-btn text dark @click="handleSavePermissionsMenu(currentUser.userId, null)" v-if="toggleDialogUsersTable === 'menus'">Salvar</v-btn>
            <v-btn icon dark @click="dialogUsers = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <v-layout d-flex align-center>
            <v-radio-group class="mb-4" v-model="toggleDialogUsersTable" hide-details dense row>
              <v-radio color="primary" label="Fields" value="fields"></v-radio>
              <v-radio color="primary" label="Actions" value="actions"></v-radio>
              <v-radio color="primary" label="Tabs" value="tabs"></v-radio>
              <v-radio color="primary" label="Steps" value="steps"></v-radio>
              <v-radio color="primary" label="Menus" value="menus"></v-radio>
            </v-radio-group>
          </v-layout>

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogUsersTable === 'fields'"
            >Campos da tela em que o usuário pode preencher e ler valores</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogUsersTable === 'actions'"
            >Botões da tela que realizam alguma ação como por exemplo alterar dados no banco</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogUsersTable === 'tabs'"
            >Abas da tela que contextualizam Fields e Actions</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogUsersTable === 'steps'">Passos de uma funcionalidade wizard</v-alert>

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogUsersTable === 'menus'">Menus!</v-alert>

          <v-data-table
            :headers="toggleDialogUsersTable !== 'menus' ? usersListPermissionsDialogHeaders : menuListPermissionsDialogHeaders"
            :items="usersListPermissionsDialog"
            :items-per-page="10"
            :search="searchUsersDialog"
            :loading="loadTableDialog"
            :footer-props="{ itemsPerPageOptions: [10, 20, 50, 100, { text: 'Todos', value: -1 }] }"
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:top>
              <v-card-title class="pt-1 elevation-0">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchUsersDialog"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                  id="input-search"
                ></v-text-field>
              </v-card-title>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-layout justify-space-between>
                <v-select
                  :items="itemsFields"
                  v-model="item.permission"
                  label="Fields"
                  append-icon="zmdi zmdi-chevron-down"
                  dense
                  :flat="true"
                  :full-width="true"
                  :height="16"
                  :hide-details="true"
                  hide-selected
                  single-line
                  small-chips
                  solo
                  background-color="transparent"
                  @change="handleSetUpdatedUserPermissionsDirect(item)"
                ></v-select>
              </v-layout>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog groups! -->
    <v-dialog v-model="dialogGroups" fullscreen hide-overlay transition="scroll-y-transition">
      <v-card>
        <v-toolbar dark color="primary rounded-0">
          <v-toolbar-title>Grupo: {{ currentGroup.groupName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn v-if="toggleDialogGroupsTable === 'portals'" @click="handleSavePermissionsPortalByGroup" text dark>
              Salvar
            </v-btn>

            <v-btn v-if="toggleDialogGroupsTable === 'menus'" @click="handleSavePermissionsMenu(null, currentGroup.groupId)" text dark>
              Salvar
            </v-btn>

            <v-btn
              v-if="toggleDialogGroupsTable !== 'menus' && toggleDialogGroupsTable !== 'portals'"
              @click="handleSavePermissionsByGroup"
              text
              dark
            >
              Salvar
            </v-btn>
            <v-btn icon dark @click="dialogGroups = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <v-layout d-flex align-center>
            <v-radio-group class="mb-4" v-model="toggleDialogGroupsTable" hide-details dense row>
              <v-radio color="primary" label="Fields" value="fields"></v-radio>
              <v-radio color="primary" label="Actions" value="actions"></v-radio>
              <v-radio color="primary" label="Tabs" value="tabs"></v-radio>
              <v-radio color="primary" label="Steps" value="steps"></v-radio>
              <v-radio color="primary" label="Menus" value="menus"></v-radio>
              <v-radio color="primary" label="Portais" value="portals"></v-radio>
            </v-radio-group>
          </v-layout>

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'fields'"
            >Campos da tela em que o usuário pode preencher e ler valores</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'actions'"
            >Botões da tela que realizam alguma ação como por exemplo alterar dados no banco</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'tabs'"
            >Abas da tela que contextualizam Fields e Actions</v-alert
          >

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'steps'">Passos de uma funcionalidade wizard</v-alert>

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'menus'">Menus do sistema</v-alert>

          <v-alert dense outlined border="left" color="info" v-if="toggleDialogGroupsTable === 'portals'">Portais do sistema</v-alert>

          <v-data-table
            v-if="toggleDialogGroupsTable !== 'portals'"
            :headers="toggleDialogGroupsTable !== 'menus' ? groupsListPermissionsDialogHeaders : menuListPermissionsDialogHeaders"
            :items="groupsListPermissionsDialog"
            :items-per-page="10"
            :search="searchGroupsDialog"
            :loading="loadTableDialog"
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:top>
              <v-card-title class="pt-1 elevation-0">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchGroupsDialog"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                  id="input-search"
                ></v-text-field>
              </v-card-title>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-layout justify-space-between>
                <v-select
                  :items="itemsFields"
                  v-model="item.permission"
                  label="Fields"
                  append-icon="zmdi zmdi-chevron-down"
                  dense
                  :flat="true"
                  :full-width="true"
                  :height="16"
                  :hide-details="true"
                  hide-selected
                  single-line
                  small-chips
                  solo
                  background-color="transparent"
                  @change="handleSetUpdatedGroupPermissionsDirect(item)"
                ></v-select>
              </v-layout>
            </template>
          </v-data-table>

          <v-data-table
            v-if="toggleDialogGroupsTable === 'portals'"
            :headers="portalsListPermissionsDialogHeaders"
            :items="groupsListPermissionsPortalsDialog"
            :items-per-page="10"
            :search="searchGroupsDialog"
            :loading="loadTableDialog"
            class="elevation-1 mb-2"
            dense
          >
            <template v-slot:top>
              <v-card-title class="pt-1 elevation-0">
                <v-spacer></v-spacer>
                <v-text-field
                  v-model="searchGroupsDialog"
                  append-icon="search"
                  label="Pesquisar"
                  single-line
                  hide-details
                  id="input-search"
                ></v-text-field>
              </v-card-title>
            </template>

            <template v-slot:[`item.action`]="{ item }">
              <v-layout justify-space-between>
                <v-select
                  :items="itemsFieldsWithoutTheDefault"
                  v-model="item.permission"
                  label="Fields"
                  append-icon="zmdi zmdi-chevron-down"
                  dense
                  :flat="true"
                  :full-width="true"
                  :height="16"
                  :hide-details="true"
                  hide-selected
                  single-line
                  small-chips
                  solo
                  background-color="transparent"
                  @change="handleSetUpdatedGroupPermissionsPortalsDirect(item)"
                ></v-select>
              </v-layout>
            </template>
          </v-data-table>
        </v-container>
      </v-card>
    </v-dialog>

    <!-- Dialog watch changes! -->
    <v-dialog v-model="dialogConfirmChanges" max-width="360" persistent transition="scroll-y-transition">
      <v-card>
        <v-toolbar dense dark color="primary rounded-0">
          <v-toolbar-title>
            <v-icon>warning</v-icon>
          </v-toolbar-title>
          <div class="flex-grow-1"></div>

          <v-icon @click="handleUndoChanges">mdi-close</v-icon>
        </v-toolbar>

        <v-card-text class="mt-2">Existe alterações não salvas, oque deseja fazer?</v-card-text>

        <v-divider></v-divider>

        <v-card-actions v-if="dialog">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsByPage">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogUsers && oldValueDialogUsersTable !== 'menus'">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsByUser">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogUsers && oldValueDialogUsersTable === 'menus'">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsMenu(currentUser.userId, null)">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar menus</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogGroups && oldValueDialogGroupsTable !== 'menus' && oldValueDialogGroupsTable !== 'portals'">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsByGroup">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogGroups && oldValueDialogGroupsTable === 'menus'">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsMenu(null, currentGroup.groupId)">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar menus</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogGroups && oldValueDialogGroupsTable === 'portals'">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsPortalByGroup">Salvar e continuar portals</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar</v-btn>
        </v-card-actions>

        <v-card-actions v-if="dialogMenus">
          <v-spacer></v-spacer>
          <v-btn color="success" @click="handleSavePermissionsByMenu">Salvar e continuar</v-btn>
          <v-btn color="error" @click="handleUndoChanges">Descartar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" top :color="snackbarColor">
      {{ snackbarMessage }}
      <template v-slot:action="{ attrs }">
        <v-icon @click="snackbar = false" class="ml-2" small color="white" v-bind="attrs">close</v-icon>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
import {
  getPages,
  getUsers,
  getGroups,
  getPageStructure,
  getListPermissionsDefault,
  savePermissionsDefault,
  getListPermission,
  getListPermissionUser,
  getListPermissionGroup,
  applyPermission,
  getListUsersPermissions,
  getListGroupsPermissions,
  getListPagesPermissions,
  getListPermissionMenu,
  getListUserGroupPermissionMenu,
  getListMenus,
  applyPermissionMenu,
  getPortalsLinkGroup,
  savePostPortalsGroups
} from '@/services/permissions';

export default {
  data: () => ({
    loadPage: true,
    loadTable: true,
    loadTableDialog: true,
    open: [],

    // --> Snackbar
    snackbar: false,
    snackbarColor: '',
    snackbarMessage: '',

    // --> Pages
    searchPages: '',
    pages: [],
    headersPages: [
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '5%'
      },
      {
        text: 'Titulo',
        align: 'left',
        sortable: true,
        value: 'titlePage',
        width: '44%'
      },
      {
        text: 'Path',
        align: 'left',
        sortable: true,
        value: 'pathName',
        width: '43%'
      }
    ],

    // --> Users
    searchUsers: '',
    searchUsersDialog: '',
    currentUser: {},
    users: [],
    headersUsersInitial: [
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '5%'
      },
      {
        text: 'Id',
        align: 'left',
        sortable: true,
        value: 'userId',
        width: '5%'
      },
      {
        text: 'Login',
        align: 'left',
        sortable: true,
        value: 'userLogin',
        width: '25%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'userName',
        width: '65%'
      }
    ],
    usersListPermissionsHeaders: [
      {
        text: 'Id',
        align: 'left',
        sortable: true,
        value: 'id',
        width: '10%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '65%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],
    usersListPermissionsDialogHeaders: [
      {
        text: 'Página',
        align: 'left',
        sortable: true,
        value: 'page',
        width: '20%'
      },
      {
        text: 'Label',
        sortable: true,
        value: 'label',
        width: '20%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '45%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],
    usersListPermissionsDialog: [],
    usersListPermissions: [],
    updatedUserPermissions: [],
    updatedUserPermissionsDirect: [],

    // --> Groups
    searchGroups: '',
    searchGroupsDialog: '',
    currentGroup: {},
    groups: [],
    headersGroupsInitial: [
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '5%'
      },
      {
        text: 'Id',
        align: 'left',
        sortable: true,
        value: 'groupId',
        width: '5%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'groupName',
        width: '90%'
      }
    ],
    headersGroupsListPermissions: [
      {
        text: 'Id',
        align: 'left',
        sortable: true,
        value: 'id',
        width: '10%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '65%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],
    groupsListPermissionsDialogHeaders: [
      {
        text: 'Página',
        align: 'left',
        sortable: true,
        value: 'page',
        width: '20%'
      },
      {
        text: 'Label',
        sortable: true,
        value: 'label',
        width: '20%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '45%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],
    groupsListPermissionsDialog: [],
    groupsListPermissions: [],
    updatedGroupPermissions: [],
    updatedGroupPermissionsDirect: [],

    // --> Menus
    searchMenus: '',
    menus: [],
    currentMenu: {},
    headersMenus: [
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '5%'
      },
      {
        text: 'id',
        align: 'left',
        sortable: true,
        value: 'id',
        width: '5%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '30%'
      },
      {
        text: 'Menu pai',
        align: 'left',
        sortable: true,
        value: 'parentName',
        width: '30%'
      },
      {
        text: 'Menu avô',
        align: 'left',
        sortable: true,
        value: 'grandParentName',
        width: '30%'
      }
    ],
    itemsUsersByMenu: [],
    itemsGroupsByMenu: [],
    headersUsersOrGroupsByMenu: [
      {
        text: 'id',
        align: 'left',
        sortable: true,
        value: 'id',
        width: '5%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '70%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],
    menuListPermissionsDialogHeaders: [
      {
        text: 'menuId',
        align: 'left',
        sortable: true,
        value: 'menuId',
        width: '10%'
      },
      {
        text: 'Nome',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '25%'
      },
      {
        text: 'Menu pai',
        align: 'left',
        sortable: true,
        value: 'parentName',
        width: '20%'
      },
      {
        text: 'Menu avô',
        align: 'left',
        sortable: true,
        value: 'grandParentName',
        width: '20%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '25%'
      }
    ],

    // --> Portals
    groupsListPermissionsPortalsDialog: [],
    portalsListPermissionsDialogHeaders: [
      {
        text: 'portalId',
        align: 'left',
        sortable: true,
        value: 'portalId',
        width: '10%'
      },
      {
        text: 'Nome do portal',
        align: 'left',
        sortable: true,
        value: 'portalName',
        width: '75%'
      },
      {
        text: '',
        value: 'action',
        sortable: false,
        align: 'center',
        width: '15%'
      }
    ],

    items: [],
    itemActive: [],
    oldItemActive: [],
    search: null,
    caseSensitive: false,

    dialog: false,
    dialogUsers: false,
    dialogGroups: false,
    dialogMenus: false,
    dialogConfirmChanges: false,

    itemsFields: [
      {
        text: 'Padrão',
        value: null
      },
      {
        text: 'Não',
        value: false
      },
      {
        text: 'Sim',
        value: true
      }
    ],

    itemsFieldsWithoutTheDefault: [
      {
        text: 'Não',
        value: false
      },
      {
        text: 'Sim',
        value: true
      }
    ],

    defaultFields: null,
    defaultFieldsLoading: false,
    defaultActions: null,
    defaultActionsLoading: false,
    defaultTabs: null,
    defaultTabsLoading: false,
    defaultSteps: null,
    defaultStepsLoading: false,
    defaultMenus: null,
    defaultMenusLoading: false,

    toggleFirstTable: 'pages',

    toggleDialogUsersTable: 'fields',
    oldValueDialogUsersTable: '',
    toggleDialogGroupsTable: 'fields',
    oldValueDialogGroupsTable: '',

    titlePage: '',
    pathName: ''
  }),

  async created() {
    await this.handleGetPages();
    await this.handleGetListPermissionsDefault();

    this.loadPage = false;
  },

  computed: {
    filter() {
      return this.caseSensitive ? (item, search, textKey) => item[textKey].indexOf(search) > -1 : undefined;
    }
  },

  methods: {
    handleUndoChanges() {
      this.updatedUserPermissions = [];
      this.updatedGroupPermissions = [];
      this.updatedUserPermissionsDirect = [];
      this.updatedGroupPermissionsDirect = [];
      this.oldItemActive = [];

      this.dialogConfirmChanges = false;
    },

    handleActiveItem(item) {
      if (this.updatedUserPermissions.length || this.updatedGroupPermissions.length) {
        this.dialogConfirmChanges = true;

        this.oldItemActive = this.itemActive;
      }

      this.itemActive = item;

      this.itemActive.length && this.handleGetListPermission();
    },

    // --> Users
    handleSetUpdatedUserPermissions(item) {
      let x = this.updatedUserPermissions.find(el => el.id === item.id);

      if (!x) this.updatedUserPermissions.push(item);
    },

    handleSetUpdatedUserPermissionsDirect(item) {
      let x = this.updatedUserPermissionsDirect.find(el => el.name === item.name);

      if (!x) {
        item.type = this.toggleDialogUsersTable;

        this.updatedUserPermissionsDirect.push(item);
      }
    },

    async handleSetUsers(item, type) {
      this.currentUser = item;

      const { userId } = item;

      if (!type) {
        this.toggleDialogUsersTable = 'fields';

        type = 'fields';
      }

      await this.handleGetListPermissionUser({ userId, type });

      this.dialogUsers = true;
    },

    async handleGetUsers() {
      try {
        const { data } = await getUsers();

        this.users = data;
      } catch (err) {
        console.error(err);
      }
    },

    async handleGetListPermissionUser(params) {
      this.loadTableDialog = true;

      const { data } = await getListPermissionUser(params);

      this.usersListPermissionsDialog = data;

      this.loadTableDialog = false;
    },

    async handleSavePermissionsByUser() {
      let userPermissions = [];
      let obj = {};

      obj.id = this.currentUser.userId;
      obj.permissions = [];

      await this.updatedUserPermissionsDirect.forEach(el => {
        let temp = {
          name: el.name,
          page: el.page,
          type: el.type,
          permissionGiven: el.permission
        };

        obj.permissions.push(temp);
      });

      userPermissions.push(obj);

      try {
        await applyPermission({ userPermissions, groupPermissions: [] });

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedUserPermissionsDirect = [];
        this.dialogConfirmChanges = false;
      }
    },

    // --> Groups
    handleSetUpdatedGroupPermissions(item) {
      let x = this.updatedGroupPermissions.find(el => el.id === item.id);

      if (!x) this.updatedGroupPermissions.push(item);
    },

    handleSetUpdatedGroupPermissionsDirect(item) {
      let x = this.updatedGroupPermissionsDirect.find(el => el.name === item.name);

      if (!x) {
        item.type = this.toggleDialogGroupsTable;

        this.updatedGroupPermissionsDirect.push(item);
      }
    },

    handleSetUpdatedGroupPermissionsPortalsDirect(item) {
      let x = this.updatedGroupPermissionsDirect.find(el => el.portalId === item.portalId);

      if (!x) this.updatedGroupPermissionsDirect.push(item);
    },

    async handleSetGroups(item, type) {
      this.currentGroup = item;

      const { groupId } = item;

      if (!type) {
        this.toggleDialogGroupsTable = 'fields';

        type = 'fields';
      }

      await this.handleGetListPermissionGroup({ groupId, type });

      this.dialogGroups = true;
    },

    async handleGetGroups() {
      try {
        const { data } = await getGroups();

        this.groups = data;
      } catch (err) {
        console.error(err);
      }
    },

    async handleGetListPermissionGroup(params) {
      this.loadTableDialog = true;

      const { data } = await getListPermissionGroup(params);

      this.groupsListPermissionsDialog = data;

      this.loadTableDialog = false;
    },

    async handleSavePermissionsByGroup() {
      let groupPermissions = [];
      let obj = {};

      obj.id = this.currentGroup.groupId;
      obj.permissions = [];

      await this.updatedGroupPermissionsDirect.forEach(el => {
        let teste = {
          name: el.name,
          page: el.page,
          type: el.type,
          permissionGiven: el.permission
        };

        obj.permissions.push(teste);
      });

      groupPermissions.push(obj);

      try {
        await applyPermission({ userPermissions: [], groupPermissions });

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedGroupPermissionsDirect = [];
        this.dialogConfirmChanges = false;
      }
    },

    async handleSavePermissionsPortalByGroup() {
      const { groupId } = this.currentGroup;

      let params = {
        groupId: this.currentGroup.groupId,
        listGroupWithPortal: []
      };

      params.listGroupWithPortal = this.groupsListPermissionsPortalsDialog;

      try {
        await savePostPortalsGroups(params);

        this.handleGetPortalsLinkGroup({ groupId });

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedGroupPermissionsDirect = [];
        this.dialogConfirmChanges = false;
      }
    },

    // --> Pages
    async handleGetPages() {
      try {
        const { data } = await getPages();

        this.pages = data;
      } catch (err) {
        console.error(err);
      }
    },

    async handleSetPage(item) {
      const { pathName, titlePage } = item;

      this.titlePage = titlePage;
      this.pathName = pathName;

      await this.handleGetPageStructure(pathName.split('.')[0]);
    },

    async handleGetPageStructure(pageName) {
      try {
        const { data } = await getPageStructure(pageName);

        this.items = data;

        this.dialog = true;

        this.itemActive = [];
      } catch (err) {
        console.error(err);
      }
    },

    async handleSavePermissionsByPage() {
      const _vm = this;

      let userPermissions = [];
      let groupPermissions = [];

      await this.updatedUserPermissions.forEach(user => {
        let obj = {};

        obj.id = user.id;
        obj.permissions = [
          {
            name: _vm.oldItemActive.length ? _vm.oldItemActive[0].id : _vm.itemActive[0].id,
            page: _vm.pathName.split('.')[0],
            type: null,
            permissionGiven: user.permission
          }
        ];

        userPermissions.push(obj);
      });

      await this.updatedGroupPermissions.forEach(group => {
        let obj = {};

        obj.id = group.id;
        obj.permissions = [
          {
            name: _vm.oldItemActive.length ? _vm.oldItemActive[0].id : _vm.itemActive[0].id,
            page: _vm.pathName.split('.')[0],
            type: null,
            permissionGiven: group.permission
          }
        ];

        groupPermissions.push(obj);
      });

      try {
        await applyPermission({ userPermissions, groupPermissions });

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedUserPermissions = [];
        this.updatedGroupPermissions = [];
        this.oldItemActive = [];

        this.dialogConfirmChanges = false;
      }
    },

    // --> Menus
    checkForChangesDialogMenus() {
      if (this.updatedUserPermissionsDirect.length > 0 || this.updatedGroupPermissionsDirect.length > 0) {
        this.dialogConfirmChanges = true;

        return;
      }

      this.dialogMenus = false;
    },

    async handleGetListMenus() {
      try {
        const { data } = await getListMenus();

        this.menus = data;
      } catch (err) {
        console.error(err);
      }
    },

    async handleSetMenu(item) {
      this.currentMenu = item;

      this.dialogMenus = true;

      try {
        const { data: isUser } = await getListUserGroupPermissionMenu({
          type: 'user',
          menuId: this.currentMenu.id
        });

        const { data: isGroup } = await getListUserGroupPermissionMenu({
          type: 'group',
          menuId: this.currentMenu.id
        });

        this.itemsUsersByMenu = isUser;
        this.itemsGroupsByMenu = isGroup;

        this.loadTableDialog = false;
      } catch (err) {
        console.error(err);
      }
    },

    async handleGetListPermissionMenu(params) {
      this.loadTableDialog = true;

      const { data } = await getListPermissionMenu(params);

      params.type === 'user' && (this.usersListPermissionsDialog = data);
      params.type === 'group' && (this.groupsListPermissionsDialog = data);

      this.loadTableDialog = false;
    },

    async handleSavePermissionsMenu(currentUserId, currentGroupId) {
      let obj = {
        userPermissions: [
          {
            id: currentUserId,
            permissionsMenu: []
          }
        ],
        groupPermissions: [
          {
            id: currentGroupId,
            permissionsMenu: []
          }
        ]
      };

      if (currentUserId) {
        await this.updatedUserPermissionsDirect.forEach(el => {
          let temp = {
            id: el.menuId,
            permissionGiven: el.permission
          };

          obj.userPermissions[0].permissionsMenu.push(temp);
        });
      } else obj.userPermissions = [];

      if (currentGroupId) {
        await this.updatedGroupPermissionsDirect.forEach(el => {
          let temp = {
            id: el.menuId,
            permissionGiven: el.permission
          };

          obj.groupPermissions[0].permissionsMenu.push(temp);
        });
      } else obj.groupPermissions = [];

      try {
        await applyPermissionMenu(obj);

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedUserPermissionsDirect = [];
        this.updatedGroupPermissionsDirect = [];
        this.dialogConfirmChanges = false;
      }
    },

    async handleSavePermissionsByMenu() {
      let obj = {
        userPermissions: [],
        groupPermissions: []
      };

      let currentMenuId = this.currentMenu.id;

      this.updatedUserPermissionsDirect &&
        this.updatedUserPermissionsDirect.map(item => {
          let temp = {
            id: item.id,
            permissionsMenu: [
              {
                id: currentMenuId,
                permissionGiven: item.permission
              }
            ]
          };

          obj.userPermissions.push(temp);
        });

      this.updatedGroupPermissionsDirect &&
        this.updatedGroupPermissionsDirect.map(item => {
          let temp = {
            id: item.id,
            permissionsMenu: [
              {
                id: currentMenuId,
                permissionGiven: item.permission
              }
            ]
          };

          obj.groupPermissions.push(temp);
        });

      try {
        await applyPermissionMenu(obj);

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissões alteradas com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.updatedUserPermissionsDirect = [];
        this.updatedGroupPermissionsDirect = [];
        this.dialogConfirmChanges = false;
        this.dialogMenus = false;
      }
    },

    // --> Portal
    async handleGetPortalsLinkGroup(params) {
      this.loadTableDialog = true;

      const { data } = await getPortalsLinkGroup(params);

      this.groupsListPermissionsPortalsDialog = data;

      this.loadTableDialog = false;
    },

    // --> Default
    async handleGetListPermissionsDefault() {
      try {
        const { data } = await getListPermissionsDefault();

        this.defaultFields = data.fieldDefault;
        this.defaultActions = data.actionDefault;
        this.defaultTabs = data.tabDefault;
        this.defaultSteps = data.stepDefault;
        this.defaultMenus = data.menuDefault;
      } catch (err) {
        console.error(err);
      }
    },

    async handleSavePermissionsDefault() {
      let params = {
        actionDefault: this.defaultActions,
        fieldDefault: this.defaultFields,
        tabDefault: this.defaultTabs,
        stepDefault: this.defaultSteps,
        menuDefault: this.defaultMenus
      };

      try {
        await savePermissionsDefault(params);

        this.snackbar = true;
        this.snackbarColor = 'success';
        this.snackbarMessage = 'Permissão padrão alterada com sucesso!';
      } catch (err) {
        console.error(err);

        this.snackbar = true;
        this.snackbarColor = 'error';
        this.snackbarMessage = 'Desculpe ocorreu um erro!';
      } finally {
        this.defaultFieldsLoading = false;
        this.defaultActionsLoading = false;
        this.defaultTabsLoading = false;
        this.defaultStepsLoading = false;
        this.defaultMenusLoading = false;
      }
    },

    async handleGetListPermission() {
      this.loadTable = true;

      try {
        const { data: users } = await getListPermission({
          objectName: this.itemActive[0].id,
          objectType: null,
          pageName: this.pathName.split('.')[0],
          type: 'user'
        });

        const { data: groups } = await getListPermission({
          objectName: this.itemActive[0].id,
          objectType: null,
          pageName: this.pathName.split('.')[0],
          type: 'group'
        });

        this.usersListPermissions = users;
        this.groupsListPermissions = groups;
      } catch (err) {
        console.error(err);
      } finally {
        this.loadTable = false;
      }
    }
  },

  watch: {
    dialog(newValue) {
      if (!newValue) {
        this.items = [];

        (this.updatedUserPermissions.length || this.updatedGroupPermissions.length) && (this.dialogConfirmChanges = true);
      }
    },

    defaultFields(newValue, oldValue) {
      if (oldValue !== null) {
        this.defaultFieldsLoading = true;

        this.handleSavePermissionsDefault();
      }
    },

    defaultActions(newValue, oldValue) {
      if (oldValue !== null) {
        this.defaultActionsLoading = true;

        this.handleSavePermissionsDefault();
      }
    },

    defaultTabs(newValue, oldValue) {
      if (oldValue !== null) {
        this.defaultTabsLoading = true;

        this.handleSavePermissionsDefault();
      }
    },

    defaultSteps(newValue, oldValue) {
      if (oldValue !== null) {
        this.defaultStepsLoading = true;

        this.handleSavePermissionsDefault();
      }
    },

    defaultMenus(newValue, oldValue) {
      if (oldValue !== null) {
        this.defaultMenusLoading = true;

        this.handleSavePermissionsDefault();
      }
    },

    toggleFirstTable(newValue) {
      if (newValue === 'menus' && !this.menus.length) this.handleGetListMenus();

      if (newValue === 'users' && !this.users.length) this.handleGetUsers();

      if (newValue === 'groups' && !this.groups.length) this.handleGetGroups();
    },

    toggleDialogUsersTable(newValue, oldValue) {
      const { userId } = this.currentUser;

      this.oldValueDialogUsersTable = oldValue;

      this.updatedUserPermissionsDirect.length && (this.dialogConfirmChanges = true);

      if (newValue !== 'menus') {
        this.handleGetListPermissionUser({ userId, type: newValue });

        return;
      }

      this.handleGetListPermissionMenu({ userGroupId: userId, type: 'user' });
    },

    toggleDialogGroupsTable(newValue, oldValue) {
      const { groupId } = this.currentGroup;

      this.oldValueDialogGroupsTable = oldValue;

      this.updatedGroupPermissionsDirect.length && (this.dialogConfirmChanges = true);

      if (newValue === 'portals') {
        this.handleGetPortalsLinkGroup({ groupId });

        return;
      }

      if (newValue === 'menus') {
        this.handleGetListPermissionMenu({ userGroupId: groupId, type: 'group' });

        return;
      }

      this.handleGetListPermissionGroup({ groupId, type: newValue });
    }
  }
};
</script>

<style lang="scss" scoped>
.v-dialog--fullscreen > .v-card {
  padding-bottom: 8px !important;
}
</style>
